import React, { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { DialogHeader, DialogHeading } from '../../Episode/Episode.Styled';
import Typography from '@mui/material/Typography';
import { useReactToPrint } from 'react-to-print';
import BackIcon from '../../common/Back/BackIcon';
import PageHeading from '../../common/Heading/PageHeading';
import { ContentTitle } from '../../ui/styled';
import Grid from '@mui/material/Grid';
import { LeftGrid } from '../../Episode/Episode.Styled';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const printStyles = `
  @media print {
    @page {
      margin: 20mm;
      @bottom-right {
        content: "Page " counter(page) " of " counter(pages);
      }
    }

    .print-footer {
      position: fixed;
      bottom: 0;
      right: 0;
      font-size: 10pt;
      padding: 10px;
    }

    .print-footer::after {
      content: counter(page);
    }
  }
`;

const InvoiceListPrintDialog = (props) => {
  const STOP_REGION = process.env.REACT_APP_STOP_REGION
  const { search, filter, invoices, openDialog, setOpenDialog } = props;
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: printStyles,
  });

  const handleClose = () => {
    setOpenDialog(false);
  };

  let total = 0;

  return (
    <Dialog
      fullScreen
      open={openDialog}
      onClose={setOpenDialog}
    >      
        <ContentTitle container>
          <Grid item xs={10}>
            <Box style={{ display: 'flex', alignItems: 'center' }}>
              <BackIcon />
              <PageHeading title='Invoice List' />
            </Box>
          </Grid>
          <LeftGrid item xs={2}>
            <Button variant="contained" onClick={() => handlePrint()}>
              Print
            </Button>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </LeftGrid>
        </ContentTitle>    

      <Box p={4} ref={componentRef}>
        <Typography variant="h5" align="center">Westcare of California STOP Area {STOP_REGION}</Typography>
        <Typography variant="h4" align="center">CBP Invoice List</Typography>
        <Typography variant="h5" align="center">{search ? search : filter?.items ? filter.items[0].columnField + ' ' + filter.items[0].operatorValue + ' ' + filter.items[0].value : ''}</Typography>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow
                sx={{backgroundColor: '#747070'}}
              >
                <TableCell align={'center'} width={50} sx={{color: '#fff', padding: '2px'}}>Cbp Inv ID</TableCell>
                <TableCell align={'center'} width={50} sx={{color: '#fff', padding: '2px'}}>Cbp ID</TableCell>
                <TableCell align={'center'} width={150} sx={{color: '#fff', padding: '2px'}}>Community Based Provider</TableCell>
                <TableCell align={'center'} width={150} sx={{color: '#fff', padding: '2px'}}>Parent Organization</TableCell>
                <TableCell align={'center'} width={50} sx={{color: '#fff', padding: '2px'}}>Month</TableCell>
                <TableCell align={'center'} width={50} sx={{color: '#fff', padding: '2px'}}>Date Faxed</TableCell>
                <TableCell align={'center'} width={50} sx={{color: '#fff', padding: '2px'}}>Date Rcvd</TableCell>
                <TableCell align={'center'} width={50} sx={{color: '#fff', padding: '2px'}}>Invoice Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                invoices.map((invoice, index) => {
                  total = total + invoice.InvoiceAmt;
                  return(
                    <>
                    <TableRow
                      key={index}
                      sx={{ '&:nth-of-type(odd)': {backgroundColor: '#eee'}, '&:last-child td, &:last-child th': { border: 0} }}
                    >
                      <TableCell align={'center'} sx={{padding: '2px'}}>
                        <Typography sx={{padding: '0px'}}>{invoice.CbpInvID}</Typography>
                      </TableCell>
                      <TableCell align={'center'} sx={{padding: '2px'}}>
                        <Typography sx={{padding: '0px'}}>{invoice.CbpID}</Typography>
                      </TableCell>
                      <TableCell align={'center'} sx={{padding: '2px'}}>
                        <Typography sx={{padding: '0px'}}>{invoice.CBPProvider}</Typography>
                      </TableCell>
                      <TableCell align={'center'} sx={{padding: '2px'}}>
                        <Typography sx={{padding: '0px'}}>{invoice.OrgZip}</Typography>
                      </TableCell>
                      <TableCell align={'center'} sx={{padding: '2px'}}>
                        <Typography sx={{padding: '0px'}}>{invoice.Month}</Typography>
                      </TableCell>
                      <TableCell align={'center'} sx={{padding: '2px'}}>
                        <Typography sx={{padding: '0px'}}>{invoice.DateFaxed}</Typography>
                      </TableCell>
                      <TableCell align={'center'} sx={{padding: '2px'}}>
                        <Typography sx={{padding: '0px'}}>{invoice.DateRecived}</Typography>
                      </TableCell>
                      <TableCell align={'right'} sx={{padding: '2px'}}>
                        <Typography sx={{padding: '0px'}}>
                          {invoice.InvoiceAmt.toLocaleString('en-US', {style: 'currency', currency: 'USD'})}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    </>
                  )
                })        
              }
              <TableRow
                sx={{backgroundColor: '#747070'}}
              >
                <TableCell align={'center'} sx={{color: '#fff', padding: '2px'}}></TableCell>
                <TableCell align={'center'} sx={{color: '#fff', padding: '2px'}}></TableCell>
                <TableCell align={'center'} sx={{color: '#fff', padding: '2px'}}></TableCell>
                <TableCell align={'center'} sx={{color: '#fff', padding: '2px'}}></TableCell>
                <TableCell align={'center'} sx={{color: '#fff', padding: '2px'}}></TableCell>
                <TableCell align={'center'} sx={{color: '#fff', padding: '2px'}}></TableCell>
                <TableCell align={'center'} sx={{color: '#fff', padding: '2px'}}>Total Amount:</TableCell>
                <TableCell align={'right'} sx={{color: '#fff', padding: '2px'}}>{total.toLocaleString('en-US', {style: 'currency', currency: 'USD'})}</TableCell>
              </TableRow>

            </TableBody>

          </Table>

        </TableContainer>
        <div className="print-footer" style={{ display: 'none' }}>
          Page
        </div>
      </Box>
    </Dialog>
  );
};

export default InvoiceListPrintDialog;
